module.exports = __webpack_public_path__ + "img/logo.white.f68c8b5c.png";